import { apiGetFleequidStats } from '~/apiClient';

export default defineNuxtPlugin({
    name: 'fleequidStats',

    async setup() {
        const {
            _raw: { apiStats },
        } = useFleequidStats();
        const { logError } = useLogs();

        if (import.meta.server) {
            try {
                const data = await apiGetFleequidStats();
                apiStats.value = data;
            } catch (error) {
                logError('Failed to fetch Fleequid stats', { error });
            }
        }
    },
});
